import { LayoutGrid, ListChecks, MessageCircle } from "lucide-react";

const STEPS = [
  {
    icon: LayoutGrid,
    title: "Pilih platform",
    desc: "Cari platform langganan yang kamu butuhkan di katalog.",
  },
  {
    icon: ListChecks,
    title: "Pilih paket",
    desc: "Bandingkan durasi dan lihat harganya sebelum memesan.",
  },
  {
    icon: MessageCircle,
    title: "Pesan lewat WhatsApp",
    desc: "Kirim detail pilihanmu untuk melanjutkan pesanan.",
  },
];

export function HowItWorks() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <h2 className="text-2xl font-bold text-nm-text sm:text-3xl">
          Cara kerjanya
        </h2>
        <p className="mt-2 text-nm-muted">
          Tiga langkah sederhana dari memilih platform hingga pesananmu diproses.
        </p>
      </div>
      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-3">
        {STEPS.map(({ icon: Icon, title, desc }, i) => (
          <div
            key={title}
            data-testid={`how-it-works-step-${i + 1}`}
            className="relative rounded-2xl border border-nm-border bg-nm-surface p-6"
          >
            <span className="absolute right-5 top-5 text-3xl font-extrabold text-white/5">
              0{i + 1}
            </span>
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-nm-red/10 text-nm-red">
              <Icon className="h-5 w-5" />
            </span>
            <h3 className="mt-4 text-lg font-bold text-nm-text">{title}</h3>
            <p className="mt-1 text-sm text-nm-muted">{desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
